import React, { createContext, useState } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [isNavOpen, setIsNavOpen] = useState(false);
    const [popupStatus, setPopupStatus] = useState(null);

    const handleNav = () => {
        setIsNavOpen(!isNavOpen);
    };

    const handlePopup = (value) => {
        sessionStorage.setItem("entry-popup", value);
        setPopupStatus(value);
        console.log(sessionStorage.getItem("entry-popup"));
    };

    return (
        <AppContext.Provider
            value={{
                isNavOpen,
                handleNav,
                popupStatus,
                handlePopup,
            }}
        >
            {children}
        </AppContext.Provider>
    );
};
